import { twMerge } from 'tailwind-merge'
import { Link } from 'react-router-dom'
import { ReactNode } from 'react'
import classNames from 'classnames'

interface BoxClassProps {
	children: ReactNode
	to?: string
	isLoading?: boolean
	className?: string
	onClick?: () => void
}

export function BoxClass({ children, className, to, onClick }: BoxClassProps) {
	return (
		<Link
			to={to ? to : '#'}
			className={twMerge(
				'flex justify-between items-center w-full min-h-44 border border-zinc-700 bg-zinc-900 p-6 rounded-xl',
				classNames(className, { 'pointer-events-none': !to })
			)}
			onClick={onClick}
		>
			{children}
		</Link>
	)
}
